import * as _ from 'underscore';
export default class Spotlights {
    constructor() {
        console.log('%c👍🏼 Spotlights', 'color: yellow');
        
        this.spotlights = document.querySelector('.spotlights-module')
        this.spotlightsList = this.spotlights.querySelector('.spotlights-list')
        this.spotlightsListResults = this.spotlights.querySelector('.spotlights-list__results')
        this.tags = []
        this.search = ""
        this.spotlightsTemplate = this.spotlights.querySelector('.spotlightsTemplate');
        this.spotlightsData;
        this.overlay = this.spotlights.querySelector('.overlay');
        this.loadMore = this.spotlights.querySelector('.spotlights__loadMore');
        this.noResults = this.spotlights.querySelector('.spotlights-list__noresults');
        this.paged = 1;
        this.blog = this.spotlights.getAttribute('data-json').includes('blog');
        this.allButton = this.spotlights.querySelector('.spotlights-map__sidebar-filter-button-all')
    }

    init() { 
        const self = this;
        this.loadMore.addEventListener( 'click', async event => {
            this.paged++;
            this.showOverlay();
            await this.loadSpotlights();
            this.hideOverlay();
            this.filterSpotlights();
        })

        const tagFilterButtons = this.spotlights.querySelectorAll('.spotlights-map__sidebar-filter-button');
        tagFilterButtons.forEach(button => {
            button.addEventListener( 'click', async event => {
                console.log('hello');
                this.paged = 1;
                this.allButton.classList.remove('spotlights-map__sidebar-filter-button-all--active');
                this.spotlightsListResults.innerHTML = '';
                button.classList.toggle('spotlights-map__sidebar-filter-button--active');
                
                const index = self.tags.indexOf(button.dataset.filter);
                if (index === -1) {
                    self.tags.push(button.dataset.filter);
                } else {
                    self.tags.splice(index, 1);
                }
                if(self.tags.length === 0) {
                    this.allButton.classList.add('spotlights-map__sidebar-filter-button-all--active');
                }

                this.showOverlay();
                await this.loadSpotlights();
                this.hideOverlay();
                this.filterSpotlights();
            })
        })

        this.allButton.addEventListener( 'click', async event => {
            this.paged = 1;
            this.spotlightsListResults.innerHTML = '';
            this.allButton.classList.add('spotlights-map__sidebar-filter-button-all--active');

            tagFilterButtons.forEach(button => {
                button.classList.remove('spotlights-map__sidebar-filter-button--active');
            })
            
            self.tags = [];
            this.showOverlay();
            await this.loadSpotlights();
            this.hideOverlay();
            this.filterSpotlights();
        })


        const inputElement = document.getElementById('searchInput');
        inputElement.addEventListener('keydown', this.debounce( async (event) => {
            this.spotlightsListResults.innerHTML = '';
            this.search = event.target.value;
            this.paged = 1;
            this.showOverlay();
            await this.loadSpotlights();
            this.hideOverlay();
            this.filterSpotlights();
        }, 1400)); 

        inputElement.addEventListener( 'search', async event => {
            this.spotlightsListResults.innerHTML = '';
            this.search = event.target.value;
            this.paged = 1;
            this.showOverlay();
            await this.loadSpotlights();
            this.hideOverlay();
            this.filterSpotlights();
        })
    }

    showOverlay() {
        this.overlay.style.display= 'flex';
    }

    hideOverlay() {
        this.overlay.style.display= 'none';
    }

   async loadSpotlights() {
        const apiString = this.getAPIString();
        const dataResponse = await fetch(apiString);
        console.log(dataResponse);
        this.spotlightsData = await dataResponse.json();
    }

    async filterSpotlights() {
        this.loadMore.parentElement.style.display= 'none';
        this.noResults.style.display= 'none';
        console.log('this.spotlightsData', this.spotlightsData);
        
        if(this.spotlightsData.spotlights.length) {
            this.spotlightsData.spotlights.forEach( spotlights => {
                this.templateSpotlights(spotlights);      
            })
        } else {
            this.noResults.style.display= 'inline';
        }
        console.log(this.spotlightsData.numPosts,  this.paged * 12)
        if(this.spotlightsData.numPosts > this.paged * 12) {
            this.loadMore.parentElement.style.display = 'block';
        }
    }

    getAPIString() {
        let string = this.spotlights.getAttribute('data-json');
        string = string + '?paged=' + this.paged + '&s=' + this.search;

        if(this.tags.length) {
            this.tags.forEach(filter => {
                string = string + "&spotlight-tag[]=" + filter;
            });
        }

        return string;
    }

    templateSpotlights(spotlights) {
        let template = _.template(this.spotlightsTemplate.innerHTML);
        let compiledResult = template(spotlights);
        this.spotlightsListResults.insertAdjacentHTML( 'beforeend', compiledResult );
    }

    debounce(func, delay) {
        let timeoutId;
    
        return function () {
          const context = this;
          const args = arguments;
    
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(context, args);
          }, delay);
        };
      }
}